import React, { useState } from 'react';
import { Facebook, Twitter, Linkedin, Link2, Share2, Instagram } from 'lucide-react';

const ShareDialog = ({ shareLabel = 'my achievement', shareUrl = 'https://https://maze.arake.app' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  const shareText = `I just completed a maze and earned ${shareLabel} on #MazeMoh 🎮`;
  const fullShareText = `${shareText}\nTry your maze ➜ ${shareUrl}`;

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        title="Share Badge"
        className="w-12 h-12 border border-white rounded-lg flex items-center justify-center bg-white/10 hover:bg-black/20 text-black"
      >
        <Share2 size={20} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="bg-white text-gray-900 rounded-lg p-6 w-full max-w-md relative">
            <button
              className="absolute top-3 right-3 text-gray-400 hover:text-black"
              onClick={() => setIsOpen(false)}
            >
              ✕
            </button>

            <h2 className="text-lg font-semibold mb-4">Share your achievement</h2>

            <div className="grid grid-cols-2 gap-4">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(shareUrl);
                  alert('Copied link! You can paste it in your Instagram story or bio.');
                }}
                className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100"
              >
                <Instagram className="w-4 h-4" /> Instagram
              </button>

              <button
                onClick={() => window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
                  '_blank')}
                className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100"
              >
                <Facebook className="w-4 h-4" /> Facebook
              </button>

              <button
                onClick={() => window.open(
                  `https://twitter.com/intent/tweet?text=${encodeURIComponent(fullShareText)}`,
                  '_blank')}
                className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100"
              >
                <Twitter className="w-4 h-4" /> X
              </button>

              <button
                onClick={() => {
                  navigator.clipboard.writeText(fullShareText);
                  window.open(
                    `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
                    '_blank');
                }}
                className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100"
              >
                <Linkedin className="w-4 h-4" /> LinkedIn
              </button>

              <button
                onClick={() => {
                  navigator.clipboard.writeText(shareUrl);
                  alert('Maze link copied to clipboard!');
                }}
                className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100 col-span-2"
              >
                <Link2 className="w-4 h-4" /> Copy Link
              </button>

              {isMobile && (
                <button
                  onClick={() => window.open(
                    `https://wa.me/?text=${encodeURIComponent(fullShareText)}`,
                    '_blank')}
                  className="flex items-center justify-center gap-2 border px-4 py-2 rounded hover:bg-white-100 col-span-2"
                >
                  <img
                    src="https://img.icons8.com/ios-filled/20/000000/whatsapp.png"
                    alt="WhatsApp"
                    className="w-4 h-4"
                  />
                  WhatsApp
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ShareDialog;
